import { ca } from '@cian/analytics';
import { EAdfoxAnalyticsPayloadType } from '../enums/EAdfoxAnalyticsPayloadType';
/** @description Отправка события по адфокс баннеру в тизер */
export var sendTeaserWebAdfoxEventFactory = function sendTeaserWebAdfoxEventFactory(payload) {
  var nested = function nested(action, useLegacyFields) {
    var bannerSource = payload.bannerSource,
      place = payload.place,
      isSp = payload.isSp,
      p1 = payload.p1,
      p2 = payload.p2,
      galleryPosition = payload.galleryPosition,
      position = payload.position,
      name__DEPRECATED = payload.name__DEPRECATED,
      place__DEPRECATED = payload.place__DEPRECATED,
      extra__DEPRECATED = payload.extra__DEPRECATED;
    var product = {
      extra: {
        action: action,
        bannerPlace: useLegacyFields ? place__DEPRECATED : place,
        bannerSource: bannerSource,
        eventDate: Date.now(),
        isSp: !!isSp,
        p1: p1,
        p2: p2
      },
      name: useLegacyFields ? "".concat(name__DEPRECATED, "_").concat(action) : "banner_".concat(action)
    };
    if (galleryPosition != null) {
      product.extra.galleryPosition = galleryPosition;
    }
    if (position != null) {
      product.position = position;
    }
    switch (payload.type) {
      case EAdfoxAnalyticsPayloadType.ErrorWithAdfoxData:
      case EAdfoxAnalyticsPayloadType.WithAdfoxData:
        product.extra.bundleName = payload.bundleName;
        product.id = payload.id;
        product.extra.campaignId = payload.campaignId;
        Object.assign(product.extra, payload.jsonFields);
        if (payload.type === EAdfoxAnalyticsPayloadType.ErrorWithAdfoxData) {
          product.extra.errorType = payload.errorType;
          product.extra.errorMessage = payload.errorMessage;
        }
        break;
      case EAdfoxAnalyticsPayloadType.WithAdfoxErrorData:
        product.extra.errorType = payload.errorType;
        product.extra.errorMessage = payload.errorMessage;
        break;
    }
    if (useLegacyFields && extra__DEPRECATED) {
      Object.assign(product.extra, extra__DEPRECATED);
    }
    ca('teaser', {
      product: product
    });
  };
  nested.payload = payload;
  return nested;
};

/** @description Отправка события по внутреннему баннеру в тизер */
export var sendTeaserWebInternalEventFactory = function sendTeaserWebInternalEventFactory(payload) {
  function nested(action) {
    var bannerSource = payload.bannerSource,
      place = payload.place,
      isSp = payload.isSp,
      name = payload.name,
      position = payload.position,
      galleryPosition = payload.galleryPosition;
    var product = {
      extra: {
        action: action,
        bannerPlace: place,
        bannerSource: bannerSource,
        eventDate: Date.now(),
        hitUrl: payload.hitUrl,
        isSp: !!isSp
      },
      id: payload.id,
      name: "".concat(name, "_").concat(action)
    };
    if (position != null) {
      product.position = position;
    }
    if (galleryPosition != null) {
      product.extra.galleryPosition = galleryPosition;
    }
    ca('teaser', {
      product: product
    });
  }
  nested.payload = payload;
  return nested;
};